import React from 'react';

import {connect} from "react-redux";
import * as cargoUtils from "../../utils/cargo";
import l10n from "../../l10n/localization";
import Loader from "../common/Loader";
import SelectCommodities from "./fields/SelectCommodities";
import Validate from 'validate.js';
import validation from '../../validation/cargo';
import DateTimePicker from "./fields/DateTimePicker";
import SelectClientRates from "./fields/SelectClientRates";
import * as cargoActions from "../../actions/cargo";
import SelectUnderwriterRates from "./fields/SelectUnderwriterRates";
import * as utils from "../../utils/utils";
import CWForm from "./CWForm";

class CargoForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utils.notNullNorUndefined(this.props.item) ? this.props.item.item : {},
            fog: this.props.item.fog,
            schema: {
                type: "object",
                properties: {
                    commodity: {
                        type: "string",
                        title: l10n.cargo.commodity,
                    },
                    quantity: {
                        type: "number",
                        title: l10n.common.quantity,
                    },
                    perTonUsd: {
                        type: "number",
                        title: l10n.cargo.perTonUsd,
                    },
                    value: {
                        type: "number",
                        title: l10n.common.value,
                    },
                    customerReference: {
                        type: "string",
                        title: l10n.cargo.customerReference
                    },
                    receiver: {
                        type: "string",
                        title: l10n.cargo.receiver,
                    },
                    blDate: {
                        type: "number",
                        title: l10n.cargo.blDate
                    },
                    blNumber: {
                        type: "string",
                        title: l10n.cargo.blNumber,
                    },
                    certificateReference: {
                        type: "string",
                        title: l10n.cargo.certificateReference
                    },
                    supplier: {
                        type: "string",
                        title: l10n.common.supplier,
                    },
                    stowage: {
                        type: "string",
                        title: l10n.cargo.stowage,
                    },
                    underwriterRate: {
                        type: "string",
                        title: l10n.cargo.underwriterRate,
                        openDrawer: this.props.openDrawer,
                        fog: this.props.fogs.getById(this.props.item.fog.id).original
                    },
                    clientRate: {
                        type: "string",
                        title: l10n.cargo.clientRate,
                        openDrawer: this.props.openDrawer,
                        fog: this.props.fogs.getById(this.props.item.fog.id).original
                    }
                }
            },
            uiSchema: {
                id: {"ui:widget": "hidden"},
                commodity: {
                    "ui:field": "selectCommodities",
                },
                blDate: {
                    "ui:field": "dateTimePicker",
                    "ui:emptyValue": ""
                },
                underwriterRate: {
                    "ui:field": "selectUnderwriterRates",
                },
                clientRate: {
                    "ui:field": "selectClientRates",
                },
                stowage: {
                    "ui:emptyValue": ""
                },
                supplier: {
                    "ui:emptyValue": ""
                },
                certificateReference: {
                    "ui:emptyValue": ""
                },
                blNumber: {
                    "ui:emptyValue": ""
                },
                customerReference: {
                    "ui:emptyValue": ""
                }
            },
            fields: {
                selectCommodities: SelectCommodities,
                dateTimePicker: DateTimePicker,
                selectUnderwriterRates: SelectUnderwriterRates,
                selectClientRates: SelectClientRates,
            },
            formData: cargoUtils.cargoToForm(utils.notNullNorUndefined(this.props.item) ? this.props.item.item : {}),
            isDirty: false
        }
    }

    componentWillMount() {
        this.props.dispatch(cargoActions.updateFormDataCargo(cargoUtils.cargoToForm(utils.notNullNorUndefined(this.props.item) ? this.props.item.item : {})));
    }

    componentDidMount() {
        /*this.props.dispatch(commodityActions.fetchCommodities(true));
        utils.notNullNorUndefined(this.props.item.fog.underwriter) &&
            this.props.dispatch(underwriterRateActions.fetchRates(this.props.item.fog.underwriter.id, true));
        utils.notNullNorUndefined(this.props.item.fog.client) &&
            this.props.dispatch(clientRateActions.fetchRates(this.props.item.fog.client.id, true));*/
    }

    componentWillUnmount() {
        this.props.dispatch(cargoActions.clearFormDataCargo());
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.item.item !== nextProps.item.item) {
            this.setState({
                item: utils.notNullNorUndefined(nextProps.item) ? nextProps.item.item : {},
                fog: nextProps.item.fog,
                formData: cargoUtils.cargoToForm(utils.notNullNorUndefined(nextProps.item) ? nextProps.item.item : {})
            });
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utils.notNullNorUndefined(this.state.item) && (utils.notNullNorUndefined(this.state.item.id) || utils.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utils.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    delete form.cargoPorts;
                    delete form.loadingPort;
                    delete form.dischargingPort;

                    if (form.excessExclusion === undefined) {
                        form.excessExclusion = false;
                    }

                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(cargoActions.edit(form, this.props.displayAll));
                })
            } else {
                this.setState({item: formData}, () => {
                    delete form.cargoPorts;
                    delete form.loadingPort;
                    delete form.dischargingPort;

                    if (form.excessExclusion === undefined) {
                        form.excessExclusion = false;
                    }
                    this.props.dispatch(cargoActions.edit(form, this.props.displayAll));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                form.fog = this.state.fog.id;
                delete form.cargoPorts;

                if (form.excessExclusion === undefined) {
                    form.excessExclusion = false;
                }
                this.props.dispatch(cargoActions.add(form, this.props.displayAll));
            })
        }
        this.props.dispatch(cargoActions.updateFormDataCargo(formData));
        this.setState((state) => {return {...state, isDirty: false,formData:formData};});
    };

    validate =  (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    calculateFields = (event) => {
        let nextFormData = Object.assign({},event.formData);

        if (nextFormData.quantity !== this.state.item.quantity) {
            nextFormData.value = nextFormData.quantity * nextFormData.perTonUsd;
            if (isNaN(nextFormData.value)) {
                nextFormData.value = 0;
            }
            this.props.dispatch(cargoActions.updateFormDataCargo(nextFormData));
            this.setState({
                ...this.state,
                item: nextFormData,
                isDirty: true,
                formData: nextFormData
            });
        } else if (nextFormData.perTonUsd !== this.state.item.perTonUsd) {
            nextFormData.value = nextFormData.quantity * nextFormData.perTonUsd;

            if (isNaN(nextFormData.value)) {
                nextFormData.value = 0;
            }
            this.props.dispatch(cargoActions.updateFormDataCargo(nextFormData));
            this.setState({
                ...this.state,
                item: nextFormData,
                isDirty: true,
                formData: nextFormData
            });

        } else if (nextFormData.value !== this.state.item.value) {
            nextFormData.perTonUsd =  nextFormData.value / nextFormData.quantity;
            if (isNaN(nextFormData.perTonUsd)) {
                nextFormData.perTonUsd = 0;
            }

            this.props.dispatch(cargoActions.updateFormDataCargo(nextFormData));
            this.setState({
                ...this.state,
                item: nextFormData,
                isDirty: true,
                formData: nextFormData
            });
        } else {
            this.handleChange(nextFormData);
        }
    };

    preprocessCalculateFields = (event) => {
        if (utils.notNullNorUndefined(this.state.item)) {
            this.calculateFields(event);
        } else {
            this.setState({item: {...event.formData}}, () => {
                this.calculateFields(event);
            })
        }
    };

    handleChange = (formData) => {
        //console.log('// call handleChange //');
        this.props.dispatch(cargoActions.updateFormDataCargo(formData));

        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(cargoActions.errorMessage(l10n.validation.form_error));
    };

    render() {

        if (this.props.loading || this.props.saving || this.props.item.fog === undefined) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'cargo-form dirty':'cargo-form';

        return (
            <div className={formClassName}>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.props.formData}
                    onSubmit={this.onSubmit}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onChange={this.preprocessCalculateFields}
                    onError={this.handleError}
                    fields={this.state.fields}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        fogs: state.fog.fogs,
        loading: state.cargo.loading,
        saving: state.cargo.saving,
        cargoes: state.cargo.cargoes,
        newlyCreatedElement: state.creation.newlyCreatedCargo,
        displayAll: state.connect.displayAll,
        formData: state.cargo.formData
    });
})(CargoForm);


// WEBPACK FOOTER //
// ./src/components/forms/CargoForm.js